import { gql } from "@apollo/client";

// Merges the order-ahead landing slug into the event's `configuration` JSONB
// (e.g. { order_ahead_slug: "summer-fest" }) via jsonb `_append`, leaving any other
// keys intact. The order-ahead app resolves this separately from the cashless slug
// (events.slug). Pass $patch = { order_ahead_slug: <value|null> }.
export const UPDATE_EVENT_ORDER_AHEAD_SLUG = gql`
  mutation UpdateEventOrderAheadSlug($eventId: Int!, $patch: jsonb!) {
    update_events(
      where: { id: { _eq: $eventId } }
      _append: { configuration: $patch }
    ) {
      affected_rows
      returning {
        id
        configuration
      }
    }
  }
`;

// Merges the order-ahead checkout field label into the event's `configuration`
// JSONB (e.g. { checkout_field_label: "Table number" }) via jsonb `_append`,
// leaving other keys intact. A non-empty label makes the order-ahead checkout
// render a required numeric input for table-service (non-pickup) menus; a null
// value hides the field. Pass $patch = { checkout_field_label: <value|null> }.
export const UPDATE_EVENT_CHECKOUT_FIELD_LABEL = gql`
  mutation UpdateEventCheckoutFieldLabel($eventId: Int!, $patch: jsonb!) {
    update_events(
      where: { id: { _eq: $eventId } }
      _append: { configuration: $patch }
    ) {
      affected_rows
      returning {
        id
        configuration
      }
    }
  }
`;
